import {
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
    ChangeDetectorRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { bdsGridModeType } from '@bds/components';

import { CommunicationMessage, CommunicationService } from '@bds/core';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { CarIdTransformService } from '@bds/helpers';

import { RtCommodityShippedGridService } from '@bds/railtrac';

import {
    RtCommodityShipped,
    RtTrip,
    RtTripRefFieldDef,
    RtvGpsLocation,
} from '@bds/railtrac-models';

import { FastracColsService } from '@bds/services';

import { faBars } from '@fortawesome/pro-solid-svg-icons';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageService } from '@bds/core';
import { CreateTripService } from '@bds/railtrac';
import { ErrorListItem } from '@bds/rt-advance-models';
import { ErrorHandlerService } from '@bds/railtrac-internal-services';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-commodity-shipped-screen',
    templateUrl: './commodity-shipped-screen.component.html',
    styleUrl: './commodity-shipped-screen.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class CommodityShippedScreenComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild('dxGridWrapper') fastracGridComponent: FastracDxGridWrapperComponent;

    public gridSource: DataSource;
    public allowModeToggle = true;
    public selectedRowKeys: number[] = [];
    public selectedRowData: any[] = [];
    public gridId = 140;
    public gridMode: bdsGridModeType = 'multiple';
    public gridStore: ODataStore;

    selectedRows: RtCommodityShipped[] = [];

    public isCreatingNew = false;

    public iconMenu = faBars;

    isDirty = false;
    errors: ErrorListItem[] = [];

    private ngUnsubscribe$: Subject<boolean> = new Subject<boolean>();

    get grid() {
        return this.fastracGridComponent?.grid;
    }

    constructor(
        public commodityShippedGridService: RtCommodityShippedGridService,
        public dialog: MatDialog,
        public router: Router,
        public route: ActivatedRoute,
        pageService: PageService,
        public snackbar: MatSnackBar,
        public gridColumnService: FastracColsService,
        public carIdTransformService: CarIdTransformService,
        public communicationService: CommunicationService,
        private clipboard: Clipboard,
        private cdr: ChangeDetectorRef,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);

        pageService.setHeader('COMMODITY SHIPPED');

        this.gridSource = this.commodityShippedGridService.getODataStore();
    }

    onSelectionChanged(selectedKeys: any[]): void {
        if (this.grid?.instance) {
            this.selectedRowData = this.grid.instance.getSelectedRowsData();
            this.selectedRows = this.selectedRowData as RtCommodityShipped[];
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        }
    }

    ngOnInit() {
        super.ngOnInit();
        // Grid repaint after view initialization
        setTimeout(() => {
            this.grid?.instance.repaint();
        }, 100);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.ngUnsubscribe$.next(true);
        this.ngUnsubscribe$.unsubscribe();
    }

    onDirty(): void {
        this.isDirty = true;
    }

    refreshGrid(): void {
        void this.grid.instance.refresh();
    }

    copyCarsToClipboard(): void {
        this.selectedRowData = this.grid.instance.getSelectedRowsData();
        if (this.selectedRowData != null && this.selectedRowData.length > 0) {
            const carIds = this.selectedRowData.map((eachRow) => {
                return (eachRow.carInit.trim() + eachRow?.carNo.trim()) as string;
            });
            const uniqueCars = [...new Set(carIds)];
            this.clipboard.copy(uniqueCars.join('\n'));
        }
    }

    onGridFastracIdChanged($event: number): void {
        super.onGridFastracIdChanged($event);
        void this.grid.instance.refresh();
    }
}
